import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IsForYou() {
  const points = ['Te hablás mal y querés cortar esa voz interna negativa.', 'Vivís comparándote y la opinión ajena te pesa de más.', 'Cargás culpa, inseguridad o miedo al fracaso que te frena.', 'Ya probaste "pensar positivo" pero no supiste cómo sostenerlo.', 'Querés un método simple, de 5 minutos al día, para aplicar desde hoy.', 'No tenés tiempo para terapias eternas: querés algo que puedas hacer solo/a, a tu ritmo.'];
  return <section className="py-20 px-4 bg-brown text-cream pt-[60px] pb-[60px]" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <h2 className="font-serif text-3xl md:text-4xl font-bold text-center mb-12 text-gold" data-id="element-108">
          Esto es para vos si…
        </h2>

        <div className="space-y-4 mb-12" data-id="element-109">
          {points.map((point, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl bg-white/5 hover:bg-white/10 transition-colors" data-id="element-110">
              <CheckCircle2 className="w-6 h-6 text-gold shrink-0 mt-0.5" data-id="element-111" />
              <p className="font-sans text-lg leading-relaxed" data-id="element-112">{point}</p>
            </motion.div>)}
        </div>

        <p className="font-serif text-2xl text-center text-gold font-bold italic" data-id="element-113">
          Si leíste esto asintiendo, ya sabés por dónde empezar.
        </p>
      </div>
    </section>;
}